<div class="font-bold text-bluegray-500 bg-bluegray-100 p-2 mx-0 uppercase border-round-top">{{titulo}}<span class="required-asterisk">*</span></div>
<div id="establishments" 
     class="p-fluid p-formgrid grid">
    <p-card *ngFor="let item of establecimientos"
            class="p-field col-12 md:col-6"
            header="{{item.name}} - {{item.nombreComercial}}" 
            subheader="{{item.description}}" 
            styleClass="surface-card">
        <ng-template pTemplate="content">
            <div *ngFor="let empt of item.emissionPoints" class="field-checkbox ng-invalid ng-dirty">
                <p-radioButton [inputId]="empt.id" name="empt.id" [value]="empt"  
                               class="field-checkbox" variant="filled"
                               [(ngModel)]="puntoEmisionSeleccionado" 
                               (onClick)="emitirPuntoEmisionEleccionado()"
                               [disabled]="!empt.habilitado || soloLectura">
                </p-radioButton> 
                <label [for]="empt.id"><strong>{{empt.name}}</strong><small class="ml-1">{{empt.description}}</small><br>
                    <small *ngIf="mostrarSecuencias == true">Última secuencia emitida <strong>[{{empt.secuencias && empt.secuencias.length ? empt.secuencias[0]['valorActual'] : '0'}}]</strong> </small>
                </label>
            </div>
            <div *ngIf="(!item.emissionPoints.length || item.emissionPoints.length == 0)">
                <strong>{{'No hay puntos de emisión habilitados para '+item.name+'.'}}</strong><br>
                {{'Configure los establecimientos según su RUC'}}
            </div>
        </ng-template>
    </p-card>
</div>